package tta.destinigo.talktoastro.feature_call_consultation.data.response.remove_queue

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import tta.destinigo.talktoastro.shared.data.CommonResponse

@Serializable
data class RemoveQueueResponse(
    @SerialName("data")val data: String?
):CommonResponse()
